import { render } from "./ResumeView.vue?vue&type=template&id=0c02cba8&scoped=true"
import script from "./ResumeView.vue?vue&type=script&lang=js"
export * from "./ResumeView.vue?vue&type=script&lang=js"

import "./ResumeView.vue?vue&type=style&index=0&id=0c02cba8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c02cba8"]])

export default __exports__